import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';
import './Admin.css';
const API_URL = process.env.REACT_APP_API_URL;
const PendingTranslatorsPage = () => {
  const { t } = useTranslation();
  const { token } = useAuth();
  
  const [translators, setTranslators] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchPendingTranslators = useCallback(async () => {
    if (!token) return;
    try {
      setLoading(true); setError('');
      const response = await fetch(`${API_URL}/api/admin/translators/pending`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error(t('error_fetch_pending_translators'));
      const data = await response.json();
      setTranslators(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [token, t]);

  useEffect(() => {
    fetchPendingTranslators();
  }, [fetchPendingTranslators]);
  
  const handleStatusUpdate = async (userId, newStatus) => {
    if (!window.confirm(t('confirm_status_change_prompt', { status: t(newStatus) }))) return;
    try {
        const response = await fetch(`${API_URL}/api/admin/translators/${userId}/status`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify({ newStatus })
        });
        if (!response.ok) throw new Error(t('error_translator_status_update'));
        // Başarı sonrası listeden kaldır
        setTranslators(prev => prev.filter(t => t.id !== userId));
        alert(t('success_translator_status_updated'));
    } catch (err) {
        alert(err.message);
    }
  };

  if (loading) return <div className="page-container"><i className="fas fa-spinner fa-spin"></i> {t('loading_pending_translators')}</div>;
  if (error) return <div className="page-container error">{error}</div>;

  return (
    <div className="page-container admin-dashboard">
	<div className="page-header">
      <h1>{t('pending_translators')}</h1>
	      </div>
      <div className="admin-table-container">
        <table className="admin-table">
          <thead>
            <tr>
              <th>{t('full_name')}</th>
              <th>{t('email_panel')}</th>
              <th>{t('application_date', 'Başvuru Tarihi')}</th>
              <th>{t('actions')}</th>
            </tr>
          </thead>
          <tbody>
            {translators.length > 0 ? translators.map(translator => (
              <tr key={translator.id}>
                <td>{translator.first_name} {translator.last_name}</td>
                <td>{translator.email}</td>
                <td>{new Date(translator.created_at).toLocaleDateString()}</td>
                <td>
                  <div className="action-buttons">
                    <button onClick={() => handleStatusUpdate(translator.id, 'approved')} className="action-btn approve">
                      <i className="fas fa-check"></i> {t('approve')}
                    </button>
                    <button onClick={() => handleStatusUpdate(translator.id, 'rejected')} className="action-btn reject">
                      <i className="fas fa-times"></i> {t('reject')}
                    </button>
                    <Link to={`/management/translators/${translator.id}`} className="action-btn view">
                        <i className="fas fa-eye"></i> {t('view_profile')}
                    </Link>
                  </div>
                </td>
              </tr>
            )) : <tr><td colSpan="4" className="empty-row">{t('no_pending_applications')}</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
	
  );
};

export default PendingTranslatorsPage;